import {
  getParams,
  isMiniProgram,
  isVzanMini as isVzanMiniApp,
} from '@/utils/utils'
import moment from 'moment' // 小程序环境
import qs from 'qs'

// 小程序内嵌页面 设置缓存参数
export default async function useMiniappParams() {
  const pagequery = getParams()
  let isminiapp = isMiniProgram()
  let AppletId = pagequery.appid || sessionStorage.getItem('miniAppid') || ''
  let isVzanMini = isVzanMiniApp()
  // 缓存基础参数
  const today = moment().format('yyyy-MM-DD')
  const cacheKey = `intheminiapp${today}`
  let baseParams = {}
  if (isminiapp) {
    // 初始小程序内嵌环境 基础参数
    baseParams = {
      fr: 'sm',
      appid: AppletId,
      isMultiUser: true,
      isCurrentSite: true,
    }
    const cacheParams = window.localStorage.getItem(cacheKey)
    // 没有缓存 或 有新的小程序appid
    if (!cacheParams || pagequery.appid) {
      // 删除多余缓存
      const carchKeyList = Object.keys(window.localStorage).filter(key =>
        key.includes('intheminiapp')
      )
      if (carchKeyList.length) {
        carchKeyList.forEach(key => {
          window.localStorage.removeItem(key)
        })
      }
      // 存入缓存
      window.localStorage.setItem(cacheKey, JSON.stringify(baseParams))
    }
  }

  // 小程序环境携带 小程序参数
  function formatMiniAppParams(config) {
    if (isminiapp) {
      if (config.method.toLowerCase() == 'get') {
        config.params = Object.assign(
          { zbid: window.zbvd.zbid },
          baseParams,
          config.params || {}
        )
      } else {
        if (config.data instanceof FormData) {
          return config
        }
        let isform = false
        if (typeof config.data == 'string' && config.data.length) {
          isform = true
          config.data = qs.parse(config.data)
        }
        const postdata = Object.assign(
          { zbid: window.zbvd.zbid },
          baseParams,
          config.data || {}
        )
        if (isform) {
          config.data = qs.stringify(postdata)
        } else {
          config.data = postdata
        }
      }
    }
    return config
  }

  return {
    formatMiniAppParams,
    isminiapp,
    AppletId,
    isVzanMini,
    baseParams,
  }
}
